import { DialogM } from "@common/components/alert/dialog/Dialog"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import {
    putCongrats,
    putNextScreenParams,
} from "@data/redux/actions/navigation"
import { activitiesService } from "@data/services/activitiesService"
import React, { useEffect } from "react"
import { connect } from "react-redux"

const ReadReviewRequestHandler = (props) => {
    useEffect(() => {
        if (props.readReviewSuccess) {
            props.apiIdle(activitiesService.readReview)
        }
        if (props.readReviewError) {
            props.apiIdle(activitiesService.readReview)
            DialogM.show({
                text1: "Erreur",
                text2: props.readReviewError.message,
            })
        }
    }, [props.readReviewSuccess, props.readReviewError])
    return <></>
}

const mapStateToProps = (state) => {
    return {
        readReviewRequest: state.api.readReview?.request,
        readReviewSuccess: state.api.readReview?.success,
        readReviewError: state.api.readReview?.error,
        readReviewSuccessData: state.api.readReview?.data,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    putNextScreenParams,
    putCongrats,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReadReviewRequestHandler)
